import dayjs from "dayjs";

export const initSessionDate =  function(session, isOldEvent) {
  const aboutNow = dayjs()  // 当前时间
  const nowYear = aboutNow.format('YYYY')
  // 新旧活动时间格式处理
  let startDate, endDate
  if (isOldEvent) {
    startDate = session.properties.startDate
    endDate = session.properties.endDate
  } else {
    startDate = session.start_date * 1000 + ''
    endDate = session.end_date * 1000 + ''
  }
  if (!(startDate && startDate.includes(' '))) {
    startDate = parseInt(startDate);
    endDate = parseInt(endDate);
  }

  const startYear = dayjs(startDate).format("YYYY")
  const endYear = dayjs(endDate).format("YYYY")


  session.sort = new Date(startDate).getTime();
  // isLiving: 这里只对比是否开始，没有转换成本地时间
  session.isLiving = dayjs(Number(startDate)) < dayjs() && dayjs() < dayjs(Number(endDate));


  let timezone = (0 - new Date().getTimezoneOffset() / 60);

  let format
  if (startYear !== endYear || (startYear === endYear && startYear !== nowYear)) {
    format = {
      cn: "YYYY年M月D日, h:mma",
      en: "MMM D, YYYY, h:mm a"
    }
  } else {
    format = {
      cn: "M月D日, h:mma",
      en: "MMM D, h:mm a"
    }
  }

  let gmt = timezone >= 0 ? 'GMT+' + timezone : 'GMT' + timezone;

  session.en = {
      startDate: dayjs(startDate).format("MMM D"),
      endDate: dayjs(endDate).format("MMM D"),
      startTime: dayjs(startDate).format("h:mmA"),
      endTime: dayjs(endDate).format("h:mmA"),
      mark: ', ',
      to: ' to ',
      gmt: `(${gmt})`,
      startFormat: dayjs(startDate).format(format['en']),
      endFormat: dayjs(endDate).format(format['en'])

  }
  session.cn = {
      startDate: dayjs(startDate).format("M月D日"),
      endDate: dayjs(endDate).format("M月D日"),
      startTime: dayjs(startDate).format("h:mmA"),
      endTime: dayjs(endDate).format("h:mmA"),
      mark: '，',
      to: ' - ',
      gmt: `(${gmt})`,
      startFormat: dayjs(startDate).format(format['cn']),
      endFormat: dayjs(endDate).format(format['cn'])
  }
}